import { api } from "@/lib/api";

const toUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

async function getSubscription() {
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/public-key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toUint8(data.key) });
  }
  return sub;
}

export async function enablePush(time) {
  const tz_offset = new Date().getTimezoneOffset();
  if (!pushSupported()) {
    await api.post("/push/reminder", { enabled: true, time, tz_offset });
    return "unsupported";
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") {
    await api.post("/push/reminder", { enabled: true, time, tz_offset });
    return "denied";
  }
  const sub = await getSubscription();
  await api.post("/push/subscribe", { subscription: sub.toJSON(), time, tz_offset });
  return "ok";
}

export async function updateReminderTime(time) {
  await api.post("/push/reminder", { enabled: true, time, tz_offset: new Date().getTimezoneOffset() });
}

export async function disablePush() {
  if (pushSupported()) {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = await reg?.pushManager.getSubscription();
    if (sub) {
      await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
      await sub.unsubscribe();
      return;
    }
  }
  await api.post("/push/reminder", { enabled: false, time: "18:00", tz_offset: new Date().getTimezoneOffset() });
}
